import React from 'react';

export default function CpfIcon(props) {
  return (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M14 7H4V5H14V7Z" fill="#111" />
      <path d="M4 11H10V9H4V11Z" fill="#111" />
      <path d="M4 0C1.79086 0 0 1.79086 0 4V12C0 14.2091 1.79086 16 4 16H16C18.2091 16 20 14.2091 20 12V4C20 1.79086 18.2091 0 16 0H4ZM16 2C17.1046 2 18 2.89543 18 4V12C18 13.1046 17.1046 14 16 14H4C2.89543 14 2 13.1046 2 12V4C2 2.89543 2.89543 2 4 2H16Z" fill="#111" />
    </svg>
  );
}
